import React from 'react';

import './index.css';

export default ({ children, handler }) => (
  <button
    className="button"
    onClick={handler}>{children}</button>
)


// WEBPACK FOOTER //
// ./src/components/button/index.jsx